import {
  Component, Input, DoCheck, ChangeDetectorRef, ChangeDetectionStrategy, OnInit
} from '@angular/core';
import { ModalAction } from './modalaction';
import {Tools} from "linkurious-shared";

@Component({
  selector: 'lk-modal-footer',
  template: `<div class="modal__footer">
  <lk-context-bubble *ngIf="errorMessage"
                     type="error"
                     event="mouseover"
                     title="There was an error. Hover for details.">
    <bubble-body>
      {{errorMessage}}
    </bubble-body>
  </lk-context-bubble>
  <div class="modal__actions" [class.disabled]="actionTriggered">
    <button class="btn"
            *ngFor="let action of actions"
            [ngClass]="{
          'btn--round': action.shape === 'round',
          'btn--sans': action.type === 'dismiss',
          'none': action.hidden(),
          'disabled': action.disable(),
          'btn--delete': action.color === 'delete',
          'btn--main': action.color === 'primary' || action.type === 'validate',
          'btn--success': action.color === 'success'
        }"
            [innerHTML]="action.label"
            (click)="triggerAction(action.onClick)"></button>
  </div>
</div>
`,
  styles: [`.modal__footer{padding:14px 20px;display:flex;align-items:center;justify-content:space-between}.modal__actions{flex:1;text-align:right}button{margin-left:5px}.btn--delete,.btn--sans{margin:0 15px}lk-context-bubble{flex:0 0 50%}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalFooterComponent implements DoCheck, OnInit {

  @Input() public actions: Array<ModalAction>;
  @Input() public errorMessage: string;
  public actionTriggered: boolean = false;
  private _oldItems: Array<{hidden: boolean; disable: boolean}>;

  constructor(
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this._oldItems = this.parseItems();
  }

  ngDoCheck() {
    if ( !Tools.isEqual(this.parseItems(), this._oldItems) ) {
      this.errorMessage = undefined;
      this._changeDetectorRef.markForCheck();
    }
    this._oldItems = this.parseItems();
  }

  private parseItems(): Array<{hidden: boolean; disable: boolean}> {
    return this.actions.map(action => {
      return {
        hidden : action.hidden(),
        disable: action.disable()
      }
    });
  }

  /**
   * Resolve promise from onClick or show a context bubble containing errors
   */
  triggerAction(onClick: Function): void {
    let action = onClick();

    if ( action instanceof Promise ) {
      this.actionTriggered = true;
      Promise.resolve(action)
        .then(e => {
          this.actionTriggered = false;
          this.errorMessage = undefined;
          this._changeDetectorRef.markForCheck();
          return Promise.resolve(e);
        })
        .catch(e => {
          this.actionTriggered = false;
          this.errorMessage = e.message;
          this._changeDetectorRef.markForCheck();
        });
    }
  }
}
